// Actions
const PREFIX = 'calculus/dialogs/';

export const OPEN_DIALOG  = PREFIX + 'OPEN_DIALOG';
export const CLOSE_DIALOG  = PREFIX + 'CLOSE_DIALOG';

// Dialogs
export const PROJECT_DETAILS_DIALOG  = PREFIX + 'PROJECT_DETAILS_DIALOG';
export const PROJECT_SAVE_DIALOG  = PREFIX + 'PROJECT_SAVE_DIALOG';
export const CREATE_NEW_PROJECT_DIALOG  = PREFIX + 'CREATE_NEW_PROJECT_DIALOG';

// Error dialogs
export const ERROR_DIALOG  = PREFIX + 'ERROR_DIALOG';

const INITIAL_STATE = {
  dialog: null,
  data: null,
  open: true,
};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case OPEN_DIALOG:
      return {
        ...state,
        ...payload,
        open: true,
      };

    case CLOSE_DIALOG:
      return {
        ...state,
        open: false,
        data: null,
      };

    default:
      return state;
  }
}

export function openDialog(payload) {
  return {
    type: OPEN_DIALOG,
    payload: payload
  };
}

export function closeDialog() {
  return {
    type: CLOSE_DIALOG,
  };
}
